const { createSlice } = require('@reduxjs/toolkit')
const initialState = {
    tatalCards:[],
    searchCards:[]
}
const BoardsData = createSlice({
  name: 'BoardsData',
  initialState,
  reducers: {
    setBoardsData: (state, action) => {
        // console.log("action payload",action)
      state.tatalCards = action.payload
    },
    setSearchData: (state, action) => {
      // console.log("action payload search",action)
    state.searchCards = action.payload
  }
  }
})

export const { setBoardsData,setSearchData } = BoardsData.actions;
export default BoardsData.reducer;